import type { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/landing-page.vue'),
    meta: {
      title: 'Workflow',
    },
  },
  {
    path: '/s',
    name: 'base',
    component: () => import('@/pages/base-route.vue'),
    children: [],
    redirect: {
      name: 'metrics',
    },
    meta: {
      title: 'Workflow',
      roles: ['System'],
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/pages/not-found.vue'),
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: () => import('@/pages/access-denied.vue'),
    meta: {
      title: 'Access Denied',
    },
  }
];

export default routes;